module.exports = __webpack_public_path__ + "static/media/downloadGCSPopupCloseButton.3eadce16.svg";